import type {
  SaveVendorConnectionPayload,
  VendorConnectionData,
  VendorConnectionStatus,
} from '@/apis/vendorConnections';

/** The status as `StatusTag` names it. */
const TAG_STATUS: Record<VendorConnectionStatus, string> = {
  not_connected: 'Not connected',
  pending: 'PENDING',
  synced: 'SYNCED',
  error: 'ERROR',
};

export const tagStatus = (status: VendorConnectionStatus): string =>
  TAG_STATUS[status] ?? 'Not connected';

/** What the form holds: one string per credential field name, plus the `enabled` switch. */
export type VendorFormValues = Record<string, string | boolean | undefined>;

/**
 * The save body for the form: only what changed, so an untouched value is never
 * sent, and clearing an optional field sends an empty value. Empty when nothing
 * changed.
 */
export const buildSavePayload = (
  vendor: VendorConnectionData,
  values: VendorFormValues
): SaveVendorConnectionPayload => {
  const credentials: Record<string, string> = {};
  for (const field of vendor.credential_fields) {
    const typed = String(values[field.name] ?? '').trim();
    const current = (field.value ?? '').trim();
    if (typed !== current && (typed || field.optional)) {
      credentials[field.name] = typed;
    }
  }
  return Object.keys(credentials).length ? { credentials } : {};
};
